module.exports = __webpack_public_path__ + "img/stickers_0004_smiley.19702103.png";